/* eslint-disable jsx-a11y/anchor-is-valid */
import { NavLink } from 'react-router-dom';
import { capitalizeEachWord } from '../../helper/lib';
import Skeleton from 'react-loading-skeleton';
import BellIcon from '../../assets/img/custom/bell.svg';
import ChatIcon from '../../assets/img/custom/chat.svg';
import ListIcon from '../../assets/img/custom/list.svg';

const AppHeader = ({
  changeCurrentPageType,
  dataNotification,
  dataProfile,
  handleClickNotifItem,
  handleLogout,
  mode,
  qbUnread,
}) => {
  return (
    <header className="main-navbar navbar-expand-md navbar-light ms-0">
      <div
        className="collapse navbar-collapse d-flex"
        id="navbarSupportedContent"
      >
        <ul className="navbar-nav me-auto hidden-sm-down w-100 bg-transparent justify-content-start justify-md-content-center align-items-center">
          <li className="nav-item me-2 d-flex d-lg-none">
            <button
              type="button"
              className="mobile-menu-button"
              data-bs-toggle="offcanvas"
              data-bs-target="#appMobileMenu"
              aria-controls="appMobileMenu"
            >
              <img
                alt="toggle-mobile-menu"
                src={ListIcon}
                className="icon-b-4"
                loading="lazy"
              />
            </button>
          </li>

          <li className="nav-item position-relative d-none d-lg-block">
            {dataProfile ? (
              <div className="fs-4 fw-bold">
                Hello,{' '}
                {capitalizeEachWord(
                  dataProfile?.name === '' || !dataProfile?.name
                    ? dataProfile?.alias === '' || !dataProfile?.alias
                      ? dataProfile?.email === '' || !dataProfile?.email
                        ? ''
                        : dataProfile?.email
                      : dataProfile?.alias
                    : dataProfile?.name
                )}
              </div>
            ) : (
              <div className="fs-4 fw-bold">
                <Skeleton width={200} />
              </div>
            )}
            {dataProfile ? (
              <div className="text-secondary">Welcome Back!</div>
            ) : (
              <Skeleton width={150} />
            )}
          </li>
        </ul>

        <ul className="navbar-nav bg-transparent d-flex align-items-center">
          <li className="nav-item me-2 me-sm-4 position-relative">
            <NavLink
              to="/seller-help"
              className="font-2xl rounded-circle"
              href="#"
            >
              <img
                alt="message"
                src={ChatIcon}
                className="icon-b-4"
                loading="lazy"
              />
            </NavLink>
          </li>

          <li className="nav-item me-2 me-sm-4 dropdown">
            <a
              className="font-2xl rounded-circle"
              href="#"
              id="QBDX05"
              role="button"
              data-toggle="dropdown"
              aria-expanded="false"
              data-flip="false"
            >
              <img
                alt="notification"
                src={BellIcon}
                className="icon-b-4"
                loading="lazy"
              />
              <span
                className={`badge rounded-circle p-1 bg-danger text-danger notif ${
                  dataNotification &&
                  dataNotification.meta &&
                  dataNotification.meta.total > 0
                    ? ''
                    : 'd-none'
                }`}
              >
                <div>
                  {dataNotification &&
                  dataNotification.meta &&
                  dataNotification.meta.total > 0
                    ? dataNotification.meta.total
                    : null}
                </div>
              </span>
            </a>

            <div
              className="dropdown-menu dropdown-menu-right p-0 border-0 w-300 will-change-0"
              style={{ width: '300px' }}
              aria-labelledby="QBDX05"
            >
              <div className="card shadow-base rounded-3 notification">
                <div
                  className="perfect-scrollbar position-relative overflow-auto"
                  style={{ maxHeight: '400px' }}
                >
                  {dataNotification?.data?.length > 0 ? (
                    <ul className="list-style-none p-3">
                      {dataNotification.data
                        ?.slice(0, 5)
                        .sort((a, b) => new Date(b.date) - new Date(a.date))
                        .map((item) => {
                          return (
                            <li
                              key={item.id}
                              onClick={() => handleClickNotifItem(item)}
                              className="list-popup-notif"
                            >
                              <div className="fw-bold fz-14">{item.title}</div>
                              <div className="fz-12 mt-2">
                                {item.content.length > 80
                                  ? item.content.substring(0, 80) + '...'
                                  : item.content}
                              </div>
                            </li>
                          );
                        })}
                    </ul>
                  ) : (
                    <div className="d-flex justify-content-center align-items-center p-3">
                      There is no new notification.
                    </div>
                  )}
                </div>
                <div className="p-3 bg-white">
                  <NavLink
                    to="/notifications"
                    className="btn fz-14 btn-fill fw-bolder w-100"
                  >
                    View All
                  </NavLink>
                </div>
              </div>
            </div>
          </li>

          <li className="nav-item me-2 me-sm-4 position-relative">
            {mode === 'designer' ? (
              <NavLink to="/messages" className="font-2xl rounded-circle">
                <img
                  alt="chat"
                  src="/dist/img/custom/chat-only-2.svg"
                  className="icon-b-4"
                  style={{ width: '1.3rem' }}
                  loading="lazy"
                />
                {qbUnread ? (
                  <span className="badge rounded-circle p-1 bg-danger text-danger notif">
                    {qbUnread}
                  </span>
                ) : (
                  ''
                )}
              </NavLink>
            ) : (
              <NavLink to="/messages" className="font-2xl rounded-circle">
                <img
                  alt="chat"
                  src="/dist/img/custom/chat-only-2.svg"
                  className="icon-b-4"
                  style={{ width: '1.3rem' }}
                  loading="lazy"
                />
                {qbUnread ? (
                  <span className="badge rounded-circle p-1 bg-danger text-danger notif">
                    {qbUnread}
                  </span>
                ) : (
                  ''
                )}
              </NavLink>
            )}
          </li>

          <li className="nav-item dropdown">
            <a
              href="#"
              className="nav-icon av-circle avatar rounded-circle p-0 overflow-hidden object-fit-cover"
              id="PJXN7R"
              role="button"
              data-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                alt="user-avatar"
                src={
                  dataProfile?.logo !== '' && dataProfile?.logo
                    ? dataProfile?.logo
                    : '/dist/img/brokenImage.jpg'
                }
                className="h-100 object-fit-cover"
                loading="lazy"
              />
            </a>
            <div
              className="dropdown-menu dropdown-menu-right shadow-sm py-2 px-3"
              aria-labelledby="PJXN7R"
            >
              {dataProfile?.merchant_type?.toLowerCase() ===
                'vendor + designer' && (
                <>
                  {mode === 'designer' ? (
                    <NavLink
                      to="/"
                      className="dropdown-item fz-14 fw-bold"
                      onClick={() => {
                        changeCurrentPageType('');
                      }}
                    >
                      Go to Vendor Mode
                    </NavLink>
                  ) : (
                    <NavLink
                      to="/"
                      className="dropdown-item fz-14 fw-bold"
                      onClick={() => {
                        changeCurrentPageType('designer');
                      }}
                    >
                      Go to Designer Mode
                    </NavLink>
                  )}
                  <div className="dropdown-divider"></div>
                </>
              )}
              <NavLink to="/profile" className="dropdown-item fz-14">
                Profile
              </NavLink>
              <div className="dropdown-divider"></div>
              <button
                id="logoutBtn"
                onClick={handleLogout}
                className="dropdown-item fz-14"
              >
                Logout
              </button>
            </div>
          </li>
        </ul>
      </div>
    </header>
  );
};

export default AppHeader;
